import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import boom from './sound/boom.ogg';
import clap from "./sound/clap.ogg"
import hihat from "./sound/hihat.ogg"
import kick from "./sound/kick.ogg"
import openhat from "./sound/openhat.ogg"
import ride from "./sound/ride.ogg"
import snare from "./sound/snare.ogg"
import tink from "./sound/tink.ogg"
import tom from "./sound/tom.ogg"








const DATA = [
	{
		key : "Q",
		keyCode: 81,
		sound : boom,
		name : "boom"

	},
	{
		key : "W",
		keyCode: 87,
		sound : clap,
		name : "clap"

	},
	{
		key : "E",
		keyCode: 69,
		sound : hihat,
		name : "hihat"
	},
	{
		key : "A",
		keyCode: 65,
		sound : kick,
		name : "kick"
	},
	{
		key : "S",
		keyCode: 83,
		sound : openhat,
		name : "openhat"
	},
	{
		key : "D",
		keyCode: 68,
		sound : ride,
		name : "ride"
	},
	{
		key : "Z",
		keyCode: 90,
		sound : snare,
		name : "snare"
	},
	{
		key : "X",
		keyCode: 88,
		sound : tink,
		name : "tink"
	},
	{
		key : "C",
		keyCode: 67,
		sound : tom,
		name : "tom"
	}
]


ReactDOM.render(<App data={DATA}/>, document.getElementById('root'));


